import React, { Component, forwardRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  Button,
  MenuItem,
  withStyles,
  Paper,
  MenuList,
  Popper,
  ClickAwayListener,
  Grow,
  Grid,
  IconButton,
} from '@material-ui/core'
import { Sort as SortIcon, ArrowLeft, ArrowRight } from '@material-ui/icons'
import { changeSort } from 'actions/tasks'
import ToggleViewButton from './ToggleViewButton'
import language from 'utils/vast-languagepack'

const SortMenu = connect(null, (dispatch) =>
  bindActionCreators({ changeSort }, dispatch),
)(
  class SortMenuComponent extends Component {
    state = {
      open: false,
    }

    handleToggle = () => {
      this.setState((state) => ({ open: !state.open }))
    }

    handleClose = (sort) => (event) => {
      if (this.anchorEl.contains(event.target)) {
        return
      }
      this.setState({ open: false })
      if (sort) this.props.changeSort(sort)
    }

    render() {
      const { classes } = this.props
      const { open } = this.state
      return (
        <div>
          <Grid container justify="space-between">
            <Grid item></Grid>
            <Grid item>
              <Button
                buttonRef={(node) => {
                  this.anchorEl = node
                }}
                aria-owns={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={this.handleToggle}
                style={{ color: '#fff' }}
              >
                <SortIcon className={classes.leftIcon} />
                {language.task.menuSort.sort}
              </Button>
            </Grid>
          </Grid>
          <Popper
            open={open}
            anchorEl={this.anchorEl}
            transition
            disablePortal
            style={{ zIndex: 1 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="menu-list-grow"
                style={{
                  transformOrigin:
                    placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={this.handleClose}>
                    <MenuList>
                      <MenuItem onClick={this.handleClose('newestFirst')}>
                        {language.task.menuSort.newestCreated}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('oldestFirst')}>
                        {language.task.menuSort.oldestCreated}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('scheduledLatest')}>
                        {language.task.menuSort.newestSchedule}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('scheduledOldest')}>
                        {language.task.menuSort.oldestSchedule}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('mostOpens')}>
                        {language.task.menuSort.mostOpens}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('mostSends')}>
                        {language.task.menuSort.mostSends}
                      </MenuItem>
                      <MenuItem onClick={this.handleClose('mostClicks')}>
                        {language.task.menuSort.mostClicks}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      )
    }
  },
)

class SortComponent extends Component {
  state = { date: '' }

  componentDidUpdate(prevProps) {
    if (prevProps.schedulerMounted !== this.props.schedulerMounted) {
      if (this.props.schedulerMounted) {
        const dateString =
          (this.props.forwardedRef &&
            this.props.forwardedRef.current &&
            this.props.forwardedRef.current.getApi &&
            this.props.forwardedRef.current.getApi().getDate &&
            this.props.forwardedRef.current
              .getApi()
              .getDate()
              .toDateString()) ||
          ''

        this.setState({
          date: `${dateString.slice(4, 7)} ${dateString.slice(11)}`,
        })
      }
    }
  }

  render() {
    const {
      classes,
      campaignPage,
      forwardedRef,
      viewSelected,
      schedulerMounted,
    } = this.props

    const component = (
      <Paper className={classes.sort}>
        <Grid container justify="space-between">
          <Grid item>
            <Grid container>
              <Grid item>
                {campaignPage ? (
                  <ToggleViewButton campaignPage icon />
                ) : (
                  <ToggleViewButton icon />
                )}
              </Grid>
              {viewSelected === 'calendar' ? (
                <Grid item>
                  <Grid container>
                    <Grid item>
                      <Button
                        size="small"
                        style={{
                          color: '#fff',
                          minWidth: 0,
                          padding: '6px 8px',
                        }}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().today(),
                          ).then(() => {
                            const dateString =
                              (this.props.forwardedRef &&
                                this.props.forwardedRef.current &&
                                this.props.forwardedRef.current.getApi &&
                                this.props.forwardedRef.current.getApi()
                                  .getDate &&
                                this.props.forwardedRef.current
                                  .getApi()
                                  .getDate()
                                  .toDateString()) ||
                              ''
                            this.setState({
                              date: `${dateString.slice(
                                4,
                                7,
                              )} ${dateString.slice(11)}`,
                            })
                          })
                        }
                      >
                        {language.task.menuSort.today}
                      </Button>
                    </Grid>
                    <Grid item>
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().prev(),
                          ).then(() => {
                            const dateString =
                              forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().getDate &&
                              forwardedRef.current
                                .getApi()
                                .getDate()
                                .toDateString()

                            this.setState({
                              date: `${dateString.slice(
                                4,
                                7,
                              )} ${dateString.slice(11)}`,
                            })
                          })
                        }
                      >
                        <ArrowLeft fontSize="small" />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <IconButton
                        className={classes.button}
                        onClick={() =>
                          Promise.resolve(
                            forwardedRef &&
                              forwardedRef.current &&
                              forwardedRef.current.getApi &&
                              forwardedRef.current.getApi().next(),
                          ).then(() => {
                            const dateString =
                              (this.props.forwardedRef &&
                                this.props.forwardedRef.current &&
                                this.props.forwardedRef.current.getApi &&
                                this.props.forwardedRef.current.getApi()
                                  .getDate &&
                                this.props.forwardedRef.current
                                  .getApi()
                                  .getDate()
                                  .toDateString()) ||
                              ''

                            // console.log(forwardedRef.current.getApi().view)

                            this.setState({
                              date: `${dateString.slice(
                                4,
                                7,
                              )} ${dateString.slice(11)}`,
                            })
                          })
                        }
                      >
                        <ArrowRight fontSize="small" />
                      </IconButton>
                    </Grid>
                    {/* <Grid item style={{ padding: 8 }}>
                      <span style={{ color: '#fff', lineHeight: '24px' }}>
                        {this.state.date}
                      </span>
                    </Grid> */}
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          </Grid>
          {viewSelected === 'calendar' ? null : (
            <Grid item>
              <SortMenu classes={classes} />
            </Grid>
          )}
          {viewSelected === 'list' ? null : (
            <Grid item>
              <Grid container>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('dayGridMonth'),
                      ).then(() => {
                        const dateString =
                          (this.props.forwardedRef &&
                            this.props.forwardedRef.current &&
                            this.props.forwardedRef.current.getApi &&
                            this.props.forwardedRef.current.getApi().getDate &&
                            this.props.forwardedRef.current
                              .getApi()
                              .getDate()
                              .toDateString()) ||
                          ''

                        this.setState({
                          date: `${dateString.slice(4, 7)} ${dateString.slice(
                            11,
                          )}`,
                        })
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.month}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('timeGridWeek'),
                      ).then(() => {
                        const dateString =
                          (this.props.forwardedRef &&
                            this.props.forwardedRef.current &&
                            this.props.forwardedRef.current.getApi &&
                            this.props.forwardedRef.current.getApi().getDate &&
                            this.props.forwardedRef.current
                              .getApi()
                              .getDate()
                              .toDateString()) ||
                          ''

                        this.setState({
                          date: `${dateString.slice(4, 7)} ${dateString.slice(
                            11,
                          )}`,
                        })
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.week}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    size="small"
                    onClick={() =>
                      Promise.resolve(
                        forwardedRef &&
                          forwardedRef.current &&
                          forwardedRef.current.getApi &&
                          forwardedRef.current
                            .getApi()
                            .changeView('timeGridDay'),
                      ).then(() => {
                        const dateString =
                          (this.props.forwardedRef &&
                            this.props.forwardedRef.current &&
                            this.props.forwardedRef.current.getApi &&
                            this.props.forwardedRef.current.getApi().getDate &&
                            this.props.forwardedRef.current
                              .getApi()
                              .getDate()
                              .toDateString()) ||
                          ''

                        this.setState({
                          date: `${dateString.slice(4, 7)} ${dateString.slice(
                            11,
                          )}`,
                        })
                      })
                    }
                    style={{ color: '#fff', minWidth: 0, padding: '6px 8px' }}
                  >
                    {language.task.menuSort.day}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Paper>
    )

    if (viewSelected === 'calendar') {
      if (schedulerMounted) {
        return component
      }
      return null
    }

    return component
  }
}

const Sort = connect(
  (state) => ({
    viewSelected: state.tasks.viewSelected,
    schedulerMounted: state.tasks.schedulerMounted,
  }),
  null,
)(
  withStyles((theme) => ({
    sort: {
      background: theme.palette.secondary.main,
      borderRadius: 25,
      textAlign: 'right',
      padding: theme.spacing.unit,
    },
    leftIcon: {
      marginRight: theme.spacing.unit,
    },
    button: {
      color: '#fff',
      [theme.breakpoints.down('xs')]: {
        padding: '6px 8px',
      },
      [theme.breakpoints.up('sm')]: {
        padding: '8px',
      },
    },
  }))(SortComponent),
)

export default forwardRef((props, ref) => (
  <Sort forwardedRef={ref} {...props} />
))
